const formatters = {};

formatters.boolToYesNo = boolVal => ((!!boolVal === true) ? 'Yes' : 'No');

formatters.number = (num, decimals) => {
  if (typeof decimals !== 'number') {
    decimals = 2;
  }

  return (num || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

formatters.currency = (amount) => {
  const sign = amount < 0 ? '-' : '';
  const abs = Math.abs(amount);

  return `${sign}$${formatters.number(abs)}`;
};

export default formatters;
